import { PROFILE_CONTENT_SX } from "./profileFieldStyles";

export const TAB_VIEW_HEADER_TOP_PADDING = { xs: 2, sm: 3, md: 4 };
export const TAB_VIEW_SIDE_PADDING_X = { xs: 2, sm: 3, md: 4 };

export const TAB_VIEW_CONTENT_WRAPPER_SX = {
  ...PROFILE_CONTENT_SX,
  px: TAB_VIEW_SIDE_PADDING_X,
  py: 4,
};

export const TAB_VIEW_HEADER_SX = {
  mx: 0,
  px: TAB_VIEW_SIDE_PADDING_X,
  pt: TAB_VIEW_HEADER_TOP_PADDING,
  "& .profile-header-tab-row::after": {
    backgroundColor: "#D2D8DE",
  },
  "& .profile-header-tabs": {
    pt: 2,
  },
  "& .profile-header-action-select": {
    minWidth: 132,
  },
  "& .profile-header-action-select .MuiOutlinedInput-notchedOutline": {
    borderRadius: "4px 4px 0 0",
    borderBottom: "none",
  },
  "& .profile-header-action-select .MuiSelect-select": {
    py: 0.72,
    fontSize: 12.5,
  },
};
